'use client'

import {useMessageEvents} from '../context/message-event-context'
import {useEffect} from 'react'

interface UseAdManagerProps {
  onShowMidroll: () => void
  onShowRewarded: () => void
  propertyCode: string
}

const useAdManager = ({onShowMidroll, onShowRewarded, propertyCode}: UseAdManagerProps) => {
  const {registerAdEvent, registerGameEvent, unregisterAdEvent, unregisterGameEvent} = useMessageEvents()
  const isGenwise = ['10628', '10629'].includes(propertyCode)

  useEffect(() => {
    if (!isGenwise) {
      registerAdEvent('midroll-ad', onShowMidroll)
    }
    registerAdEvent('nonskipvideo', onShowRewarded)

    return () => {
      if (!isGenwise) {
        unregisterAdEvent('midroll-ad', onShowMidroll)
      }
      unregisterAdEvent('nonskipvideo', onShowRewarded)
    }
  }, [registerAdEvent, unregisterAdEvent, onShowMidroll, onShowRewarded, registerGameEvent, unregisterGameEvent])
}

export default useAdManager
